import { path } from 'ramda';

export const getIsLoggedInStatus = path(['authentication', 'isLoggedIn'])
export const getAuthenticationError = path(['authentication', 'error'])